module.exports = __webpack_public_path__ + "img/loading.2f112a1f.png";